import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue';
import { TradeFundingDetails, ClientRiskCollateralProfile } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { ErrorExclamationIcon } from 'ah-common-lib/src/icons/components';
import PostCollateralTransactionExecutor from '../../limitsAndCollateral/manageCollateral/PostCollateralTransactionExecutor.vue';
import DataRow from 'ah-common-lib/src/common/components/DataRow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeFundForm',
  props: {
  collateralProfile: {
    type: Object as PropType<ClientRiskCollateralProfile>,
    required: true,
  },
  currency: {
    type: String,
    required: true,
  },
  isFundWithCollateralPossible: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:tradeFundingDetails", "reload-collaterals"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:tradeFundingDetails', value: Partial<TradeFundingDetails>): void;
  (e: 'reload-collaterals'): void;
}), expose: any, slots: any, attrs: any }) {





const hasPostedCollateral = ref(false);

function reCheckCollaterals() {
  hasPostedCollateral.value = true;
  emit('reload-collaterals');
}

return { __sfc: true,emit, hasPostedCollateral, reCheckCollaterals, formatCurrencyValue, ErrorExclamationIcon, PostCollateralTransactionExecutor, DataRow }
}

})